import moment from "moment";
import sortBy from "lodash/sortBy";
import StationModel from "../models/stationModel";
import each from "lodash/each";
import min from "lodash/min";
import max from "lodash/max";
import isEmpty from "lodash/isEmpty";
import { cropr, gettext, pgettext } from "../adapter";
import { saveAs } from "./globalUtils";
import weatherStationActions from "../actions/weatherStationActions";

const parseStations = (items) => {
  var stations = items;

  stations = stations.map(function (station, index) {
    var year = moment(station.active_period_start * 1000).year();
    var r = new StationModel({
      id: station.id,
      period: station.period,
      year: station.period === "past" ? year : moment().year(),
      name: station.name,
      serialNumber: station.serial_number,
      latitude: station.latitude,
      longitude: station.longitude,
      showAllMeasurements: station.show_all_measurements,
      showFiveMinutesMeasurements: station.show_five_minutes_measurements,
    });

    return r;
  });
  return sortBy(stations, "name");
};

const parseStation = (rawStation) => {
  var latestMeasurement = false;

  var chill = rawStation.latitude < -22.0;
  chill = chill && rawStation.longitude > 16.0;
  chill = chill && rawStation.longitude < 33.0;

  var station = new StationModel({
    id: rawStation.id,
    name: rawStation.name, //+url,
    latitude: rawStation.latitude,
    longitude: rawStation.longitude,
    enabled: rawStation.powered_on,
    active: rawStation.has_recent_measurements,
    activePeriodStart: rawStation.active_period_start,
    activePeriodEnd: rawStation.active_period_end,
    serialNumber: rawStation.serial_number,
    latestMeasurement: latestMeasurement,
    showAllMeasurements: rawStation.show_all_measurements,
    showFiveMinutesMeasurements: rawStation.show_five_minutes_measurements,
    day_measurements: rawStation.day_measurements,
    meta: rawStation.sensors,
  });
  station.chill = chill;

  // Calculate the timezone offset
  var d = new Date();
  var timezoneOffset = d.getTimezoneOffset() * 60000;

  // Values we will measure
  var airTemperature = [];
  var relativeHumidity = [];
  var radiation = [];
  var windSpeed = [];
  var precipitation = [];
  var windDirection = [];

  var allAirTemperatureValues = [];
  var allRelativeHumidityValues = [];
  var allWindSpeedValues = [];

  each(rawStation.measurements, function (measurement, key) {
    allAirTemperatureValues.push(
      cropr.l10n_utils.celsius_to_l10n(measurement.values.air_temperature)
    );
    allRelativeHumidityValues.push(measurement.values.rel_humidity);
    allWindSpeedValues.push(measurement.values.wind_speed);
  });

  // save the raw measurements
  station.measurements.raw = rawStation.measurements;
  var maxAirTemperature = max(allAirTemperatureValues);
  var minAirTemperature = min(allAirTemperatureValues);
  if (maxAirTemperature === minAirTemperature) {
    maxAirTemperature = 100;
  }

  var maxRelativeHumidity = max(allRelativeHumidityValues);
  var minRelativeHumidity = min(allRelativeHumidityValues);
  if (maxRelativeHumidity === minRelativeHumidity) {
    maxRelativeHumidity = 100;
  }

  var maxWindSpeed = max(allWindSpeedValues);
  var minWindSpeed = min(allWindSpeedValues);
  if (maxWindSpeed === minWindSpeed) {
    maxWindSpeed = 100;
  }

  var airTemperatureScale = 100 / (maxAirTemperature - minAirTemperature);
  var relativeHumidityScale = 100 / (maxRelativeHumidity - minRelativeHumidity);
  var windSpeedScale = 100 / (maxWindSpeed - minWindSpeed);

  each(rawStation.measurements, function (measurement, key) {
    var timestamp = measurement.timestamp * 1000 + timezoneOffset;
    var date = new Date(parseInt(timestamp));

    // Add rain to the measurements
    precipitation.push({
      timestamp: date,
      y: measurement.values.precipitation,
    });

    // @TODO: See if we need the speed
    windDirection.push({
      timestamp: date,
      y: measurement.values.wind_speed,
      direction: measurement.values.wind_direction,
    });

    airTemperature.push({
      x: timestamp,
      y: cropr.l10n_utils.celsius_to_l10n(measurement.values.air_temperature) * airTemperatureScale,
      timestamp: date,
    });

    windSpeed.push({
      x: timestamp,
      y: measurement.values.wind_speed * windSpeedScale,
      timestamp: date,
    });

    relativeHumidity.push({
      x: timestamp,
      y: measurement.values.rel_humidity * relativeHumidityScale,
      timestamp: date,
    });

    radiation.push({
      timestamp: date,
      y: measurement.values.radiation ? measurement.values.radiation : 0,
    });
  });

  var airTemperatureBrush = compressContinuous(airTemperature, airTemperatureScale, true);
  airTemperature = compressContinuous(airTemperature, airTemperatureScale, false);
  relativeHumidity = compressContinuous(relativeHumidity, relativeHumidityScale, false);
  windSpeed = compressContinuous(windSpeed, windSpeedScale, false);

  station.measurements.airTemperatureBrush = airTemperatureBrush;
  station.measurements.airTemperature = airTemperature;
  station.measurements.precipitation = precipitation;
  station.measurements.windSpeed = windSpeed;
  station.measurements.relativeHumidity = relativeHumidity;
  station.measurements.radiation = radiation;
  station.measurements.windDirection = windDirection;

  // The last data point we received
  var ldp = false;
  if (!isEmpty(station.measurements.airTemperature)) {
    ldp = station.measurements.airTemperature[station.measurements.airTemperature.length - 1];
  }

  var firstDataPointTimestamp = false;

  if (rawStation.measurements && rawStation.measurements[0]) {
    firstDataPointTimestamp = rawStation.measurements[0].timestamp;
  }

  // var lastDataPoint;
  var firstDataPoint;
  if (ldp && firstDataPointTimestamp) {
    // lastDataPoint = new Date(parseInt(ldp.timestamp + timezoneOffset));
    firstDataPoint = new Date(parseInt(firstDataPointTimestamp * 1000 + timezoneOffset));

    var domain = [];
    domain.push(new Date(firstDataPointTimestamp * 1000 + timezoneOffset));
    domain.push(ldp.timestamp);
  }

  station.firstDataPointDate = firstDataPoint;
  station.lastDataPointDate = ldp.timestamp;

  return { station, defaultDomain: domain, lastDataPoint: station.lastDataPointDate };
};

const compressContinuous = (data, scale, brush) => {
  return data.map(function (measurement) {
    return { timestamp: measurement.timestamp, y: measurement.y / scale };
  });
};

const export2Csv = (station) => {
  var valuescsv = "date\ttime";
  var d = new Date();
  var offset = d.getTimezoneOffset() * 1000 * 60;
  var units = {
    air_temperature: cropr.l10n.unit_temp_display,
    precipitation: cropr.l10n.unit_precipitation_display,
    radiation: gettext("J/cm\u00b2"),
    rel_humidity: "%",
    radiation_short: "W/m\u00b2",
    wind_direction: "\u00b0",
    wind_speed: cropr.l10n.unit_windspeed_display,
    cloud: "unit 1-8",
  };

  //output the table header
  each(station.measurements.raw[0].values, function (measurement, key) {
    //do not include depths
    if (key !== "depths") {
      valuescsv += "\t" + key;
    }
  });

  valuescsv += "\r\n\t";

  each(station.measurements.raw[0].values, function (measurement, key) {
    //do not include depths
    if (key !== "depths") {
      valuescsv += "\t" + units[key];
    }
  });

  //output the actual measurement values
  each(station.measurements.raw, function (measurement, key) {
    valuescsv += "\r\n";
    var ts = new Date(measurement.timestamp * 1000 + offset);

    valuescsv +=
      moment(ts)
        .format("L")
        .replace(/\u200e/g, "") + "\t"; // the unicode 200e sign is an IE bug, so remove those characters.
    valuescsv += moment(ts)
      .format("LT")
      .replace(/\u200e/g, "");

    each(measurement.values, function (mval, keyinner) {
      // only include finite numbers
      if (Number.isFinite(mval)) {
        switch (keyinner) {
          case "precipitation":
            mval = cropr.l10n_utils.mm_to_l10n(mval);
            break;
          case "air_temperature":
            mval = cropr.toLocaleFixed(cropr.l10n_utils.celsius_to_l10n(mval), 2);
            break;
          case "wind_speed":
            mval = cropr.toLocaleFixed(cropr.l10n_utils.mps_to_l10n(mval), 2);
            break;
          default:
            mval = cropr.toLocaleFixed(mval, 2);
            break;
        }

        valuescsv += "\t" + mval;
      } else {
        //do not include depths
        if (keyinner !== "depths") {
          valuescsv += "\t";
        }
      }
    });
  });
  saveAs(valuescsv, "dacom_weather_data.csv");
};

const exportDay2Csv = (dcolumns, dataSetday) => {
  var valuescsv = "";

  //output the table header
  each(dcolumns, function (c) {
    //do not include depths
    valuescsv += c.title + "\t";
  });
  valuescsv += "\r\n";

  //output the actual measurement values
  each(dataSetday, function (mval, keyinner) {
    each(dcolumns, function (d, key) {
      if (mval[d.name]) {
        valuescsv += mval[d.name].toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      valuescsv += "\t";
    });
    valuescsv += "\r\n";
  });
  saveAs(valuescsv, "dacom_weather_day.csv");
};

const calcMean = (arr) => {
  var tot = 0;
  for (var i = 0; i < arr.length; i++) {
    tot = tot + arr[i];
  }
  return tot / arr.length;
};

const calcHeat = (arr) => {
  var mean = calcMean(arr);
  var ret = 0;
  if (mean >= 7.0) {
    if (mean <= 20.0) {
      ret = mean - 7.0;
    } else {
      ret = 20.0 - 7.0;
    }
  }
  return ret;
};

const calcRich = (arr) => {
  var aRich1 = [17.99, 15.99, 12.49, 9.19, 2.45, 1.45];
  var aRich2 = [-1.0, -0.5, 0.0, 0.5, 1.0, 0.5];
  var tot = 0;
  for (var i = 0; i < arr.length; i++) {
    // not working in IE:
    //var index = aRich1.findIndex(function(el){ return arr[i] >= el; })
    var index = -1;
    for (var j = 0; j < aRich1.length; j++) {
      if (arr[i] >= aRich1[j]) {
        index = j;
        break;
      }
    }
    if (index >= 0) {
      tot = tot + aRich2[index];
    }
  }
  return tot;
};

const calcMin = (arr) => {
  var ret = 10000000.0;
  for (var i = 0; i < arr.length; i++) {
    ret = Math.min(ret, arr[i]);
  }
  return ret;
};

const calcMax = (arr) => {
  var ret = -10000000.0;
  for (var i = 0; i < arr.length; i++) {
    ret = Math.max(ret, arr[i]);
  }
  return ret;
};

const calcWinddir = (gr) => {
  var grcor = (gr + 11.25) % 360;
  return [
    pgettext("wind direction abbreviation", "N"),
    pgettext("wind direction abbreviation", "NNE"),
    pgettext("wind direction abbreviation", "NE"),
    pgettext("wind direction abbreviation", "ENE"),
    pgettext("wind direction abbreviation", "E"),
    pgettext("wind direction abbreviation", "ESE"),
    pgettext("wind direction abbreviation", "SE"),
    pgettext("wind direction abbreviation", "SSE"),
    pgettext("wind direction abbreviation", "S"),
    pgettext("wind direction abbreviation", "SSW"),
    pgettext("wind direction abbreviation", "SW"),
    pgettext("wind direction abbreviation", "WSW"),
    pgettext("wind direction abbreviation", "W"),
    pgettext("wind direction abbreviation", "WNW"),
    pgettext("wind direction abbreviation", "NW"),
    pgettext("wind direction abbreviation", "NNW"),
    pgettext("wind direction abbreviation", "??"),
  ][parseInt(grcor / 22.5)];
};

// Callback used by the shared DateRangeField that replaces the old jQuery
// daterangepicker. Emits the domain change into the redux store.
const applyDateRange = (station, dispatch) => (start, end) => {
  dispatch(weatherStationActions.brushDomain([start, end]));
};

// Callback for a full (server-refetching) date range pick.
const applyFullDateRange = (apiUrl, station, dispatch) => (start, end) => {
  const offset = new Date().getTimezoneOffset() * 60;
  dispatch(
    weatherStationActions.fetchStation(
      apiUrl,
      station.id,
      station.showAllMeasurements,
      station.showFiveMinutesMeasurements,
      [Math.round(start.getTime() / 1000) - offset, Math.round(end.getTime() / 1000) - offset + 1]
    )
  );
};

export {
  applyDateRange,
  applyFullDateRange,
  parseStations,
  parseStation,
  export2Csv,
  exportDay2Csv,
  calcWinddir,
  calcMax,
  calcMin,
  calcRich,
  calcHeat,
  calcMean,
};
